require('./index.scss')

import PropTypes from 'prop-types'

import { isCheckoutPath } from '@/utils/path'
import { routeFor } from '@/utils/router'
import { translate } from '@/utils/translations'

import CheckoutIcon from './CheckoutIcon'
import ReadIcon from './ReadIcon'
import ViewCartIcon from './ViewCartIcon'

const CART_STYLES = [
  'underline',
  'progress-tracker__text-step'
].join(' ')

const CartProgressHeader = ({ cartStepNumber }) => {
  const stepClass = step => step <= cartStepNumber ? 'active' : 'inactive'
  const ariaCurrentForStep = step => (
    step === cartStepNumber ? { 'aria-current': 'step' } : {}
  )

  return (
    <ol className='progress-tracker'>
      <li {...ariaCurrentForStep(1)} >
        <Choose>
          <When condition={isCheckoutPath}>
            <a
              className={'d-flex flex-column'}
              data-testid="cart-nav-btn-checkout-page"
              href={routeFor('cart')}
            >
              <div className={`progress-tracker__icon-step ${stepClass(1)}`}>
                <ViewCartIcon />
              </div>
              <span className={`${CART_STYLES} ${stepClass(1)}`}>
                {translate('carts.view_cart')}
              </span>
            </a>
          </When>
          <Otherwise>
            <div className={`progress-tracker__icon-step ${stepClass(1)}`}>
              <ViewCartIcon />
            </div>
            <span className={`progress-tracker__text-step ${stepClass(1)}`}>
              {translate('carts.view_cart')}
            </span>
          </Otherwise>
        </Choose>
      </li>
      <li className='progress-tracker__divider' {...ariaCurrentForStep(2)}>
        <div className={`progress-tracker__icon-step ${stepClass(2)}`}>
          <CheckoutIcon />
        </div>
        <span className={`progress-tracker__text-step ${stepClass(2)}`}>
          {translate('carts.checkout')}
        </span>
      </li>
      <li className='progress-tracker__divider' {...ariaCurrentForStep(3)}>
        <div className={`progress-tracker__icon-step ${stepClass(3)}`}>
          <ReadIcon />
        </div>
        <span className={`progress-tracker__text-step ${stepClass(3)}`}>
          {translate('carts.read')}
        </span>
      </li>
    </ol>
  )
}

CartProgressHeader.propTypes = {
  cartStepNumber: PropTypes.number.isRequired
}

export default CartProgressHeader
